module.exports = __webpack_public_path__ + "static/img/Yajie_Zhang.256e7e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/people/Yajie_Zhang.png
// module id = IoSt
// module chunks = 1